import React from 'react';

import Logo from '../UI/Logo/Logo';
import styles from './Copyright.module.css';
import LinkItem from '../UI/LinkItem/LinkItem';
import { getClassName } from '../../components/UI/ResponsiveWrapper/ResponsiveWrapper';

/**
 * TODO
 * Add social network icons
 */

const Copyright = () => {
  return (
    <div className={styles.Copyright}>
      <div className={styles.Container + ` ${getClassName()}`}>
        <div className={styles.InnerContainer}>
          &copy; 2024
          <div className={styles.Logo}>
            <Logo height={"15"} width={"28"} />
          </div>
          Autokino Wien
        </div>
        <div className={[styles.InnerContainer, styles.Links].join(' ')}>
          <LinkItem url="/privacy" alt="Datenschutzerkl&auml;rung">
            Datenschutzerkl&auml;rung
          </LinkItem>
          <LinkItem url="/agb" alt="AGBs">
            AGBs
          </LinkItem>
        </div>
      </div>
    </div>
  );
};

export default Copyright;
